import { connect, } from 'react-redux';
import VehicleInfoComponent from '../components/VehicleInfo';

const mapStateToProps = ({vehicle, consumerReviewAndRating, expertReviewAndRating, }: any,) => {
  const { makeName, modelName, trimName, yearId, } = vehicle;
  let vehicleTitle = `${makeName} ${modelName}`;
  if (yearId !== 0) {
    vehicleTitle = `${yearId} ${vehicleTitle}`;
  }
  const vehicleTrimName = trimName || '';
  return {
    vehicleTitle,
    vehicleTrimName,
    consumerReviewAndRating,
    expertReviewAndRating,
  };
};

export default connect(mapStateToProps,)(VehicleInfoComponent,);
